export default {"src":"/_next/static/media/web-signature.08a9ba81.svg","height":355,"width":665};